/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import './checkboxes-tags.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function CheckboxesTagsSingle({
  options,
  selected,
  setSelected,
  label,
}) {
  const [checked, setChecked] = useState(options);
  const result = checked.findIndex((el) => el.id === selected[i].id);
  const defaultArray = checked[result];

  /*for (let i = 0; i < selected.length; i += 1) {
    defaultArray.push(checked[result]);
  }*/

  return (
    <Autocomplete
      
      id="checkboxes-tags-demo"
      options={checked}
      disableCloseOnSelect
      getOptionLabel={(option) => option.title || option.name}
      renderOption={(option, state) => (
        <>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={state.selected}
          />
          {option.title || option.name}
        </>
      )}
      defaultValue={defaultArray}
      style={{ width: '100%' }}
      onChange={(event, value) => {
        setSelected(value);
      }}
      renderInput={(params) => (
        <TextField
          value="helo"
          fullWidth
          InputLabelProps={params.InputLabelProps}
          InputProps={params.InputProps}
          id={params.id}
          inputProps={params.inputProps}
          label={label}
        />
      )}
    />
  );
}

CheckboxesTagsSingle.propTypes = {
  options: PropTypes.array,
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  label: PropTypes.string,
};

CheckboxesTagsSingle.defaultProps = {
  options: [],
  selected: [],
  setSelected: () => {},
  label: '',
};
